import type { Locale } from './i18n'
import { supabase } from './supabase'
import { subscriptionPlans, type SubscriptionPlanDefinition } from './subscriptions'

export interface SubscriptionPlanCatalogRow {
  tier: SubscriptionPlanDefinition['tier']
  monthly_price_cents: number
  annual_price_cents: number
  team_member_limit: number
  client_limit: number | null
  subtitle_localizations: Record<Locale, string>
  feature_localizations: Record<Locale, string[]>
  is_recommended: boolean
  is_enabled: boolean
  sort_order: number
  updated_at?: string
}

export async function fetchSubscriptionCatalogRows(includeDisabled = false) {
  let query = supabase
    .from('subscription_plan_catalog')
    .select('*')
    .order('sort_order')
  if (!includeDisabled) query = query.eq('is_enabled', true)
  const { data, error } = await query
  if (error) throw error
  return (data ?? []) as SubscriptionPlanCatalogRow[]
}

export async function fetchSubscriptionPlans(locale: Locale) {
  const rows = await fetchSubscriptionCatalogRows(false)
  if (rows.length === 0) return subscriptionPlans
  return rows.map((row): SubscriptionPlanDefinition => ({
    tier: row.tier,
    monthlyPriceCents: row.monthly_price_cents,
    annualPriceCents: row.annual_price_cents,
    teamMemberLimit: row.team_member_limit,
    clientLimit: row.client_limit,
    recommended: row.is_recommended,
    subtitle: row.subtitle_localizations[locale] ?? row.subtitle_localizations.en,
    features: row.feature_localizations[locale] ?? row.feature_localizations.en,
  }))
}
